import { render } from "./tagEditor.vue?vue&type=template&id=eae1a932"
import script from "./tagEditor.vue?vue&type=script&lang=js"
export * from "./tagEditor.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__